<div class="row  align-content-center" mat-dialog-title>
    <div class="col-md-auto d-flex align-items-center">
        <mat-icon class="mr-2 alet" *ngIf="contenido.icoAlert">error_outline</mat-icon>
        <mat-icon class="mr-2 inf" *ngIf="contenido.icoInf">notifications_none</mat-icon>
        <mat-icon class="mr-2 err" *ngIf="contenido.icoError">not_interested</mat-icon>
        {{contenido.titulo | titlecase}}</div>
    <!-- <div class="col-md-auto d-flex align-items-center">
        <mat-icon class="ico-delet mb-0" (click)="dialogRef.close()" style="cursor: pointer;">close</mat-icon>
    </div> -->
</div>
<mat-dialog-content>
    <div class="row  m-2">
        <span class="text-center w-100">
            <!-- <mat-icon class="icoTamanio alet" *ngIf="contenido.icoAlert">error_outline</mat-icon>
            <mat-icon class="icoTamanio inf" *ngIf="contenido.icoInf">notifications_none</mat-icon>
            <mat-icon class="icoTamanio err" *ngIf="contenido.icoError">highlight_off</mat-icon> -->
        </span>
        <p *ngIf="contenido.cuerpoParrafo1" >{{contenido.cuerpoParrafo1}}</p>
        <p *ngIf="contenido.cuerpoParrafo2" >{{contenido.cuerpoParrafo2}}</p>
        <p *ngIf="contenido.cuerpoParrafo3" >{{contenido.cuerpoParrafo3}}</p>
        <p *ngIf="contenido.cuerpoParrafo4" >{{contenido.cuerpoParrafo4}}</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div [ngClass]="contenido.botonCancelar && contenido.botonAceptar ? 'd-flex justify-content-around w-100' : 'd-flex justify-content-center w-100'">
        <div class="col-auto" *ngIf="contenido.botonCancelar">
            <button mat-stroked-button color="warn" (click)="dialogRef.close(false)" class="btnCerrar">
                {{contenido.botonCancelar | titlecase}}
            </button>
        </div>
        <div class="col-auto" *ngIf="contenido.botonAceptar">
            <button mat-flat-button color="primary"  (click)="dialogRef.close(true)">
                {{contenido.botonAceptar | titlecase}}
            </button>
        </div>
    </div>
</mat-dialog-actions>